import { socketClosedListeners } from './socketClosedListeners'

/** Tells every registered listener the socket closed. Called from the graphql-ws client's `on.closed` option. */
export const notifySocketClosed = (): void => {
  socketClosedListeners.forEach((listener) => listener())
}
